import { assignTabDataAndDispatch } from 'state/tabs/actions';
import * as types from './constants';

export function setSelectedHistory(index) {
  return assignTabDataAndDispatch({ type: types.SET_SELECTED_HISTORY, index });
}
